import i18n from "../../../../locales";
import { SagaIterator } from "redux-saga";
import { requester } from "../../../../libs/requester";
import { call, takeLatest } from "redux-saga/effects";
import { links } from "../../../../utils/links";
import { createNotification } from "../../../../utils/createNotification";

interface IAddToWaitingWorker {
  type: string;
  payload: {
    payload: number;
  };
}

function* addToWaitingWorker({ payload }: IAddToWaitingWorker): SagaIterator {
  try {
    const { isError, message } = yield call(
      requester.post,
      links.addToWaiting,
      { productId: payload }
    );
    if (isError) {
      createNotification({
        title: i18n.t("error"),
        message,
        type: "danger",
      });
    } else {
      createNotification({
        title: i18n.t("successAddedWaiting"),
        message,
        type: "success",
      });
    }
  } catch (error) {
    console.error("addToWaitingWorker: ", error);
  }
}

export function* addToWaitingWatcher() {
  yield takeLatest("@saga/ADD_TO_WAITING", addToWaitingWorker);
}
